import {
  Form,
  Input,
  FormFeedback,
  Button,
  Label,
  FormGroup,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { forgotPassword } from "../../api/auth";
import ResultHandler from "../../components/ResultHandler";
import logo from "../../assets/images/QN-logo-mini.png";
import useCustomValidation from "../dashboard/validationSchema";
import { useResponse } from "../../hooks/useResponse";
import { useState } from "react";
import toast from "react-hot-toast";

const ForgotPassword = () => {
  const { forgotPasswordSchema } = useCustomValidation();
  const history = useHistory();

  const { setData, loading, error } = useResponse(forgotPassword, (res) => {
    toast.success("We sent a code to you email");
    history.push("/reset-password");
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { email: localStorage.getItem("email") || "" },
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      localStorage.setItem("email", values.email);
      setData({ type: "add", data: { ...values } });
    },
  });

  return (
    <div style={{ minHeight: "100vh" }}>
      <div
        className="text-start w-100 p-3"
        style={{ cursor: "pointer" }}
        onClick={() => history.goBack()}
      >
        <i class="bx bx-arrow-back font-size-16 fw-bold"></i>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-column">
        <div
          className="d-flex justify-content-center align-items-center flex-column p-3"
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <div style={{ height: "80px", width: "80px" }}>
            <img src={logo} alt="logo" className="w-100 h-100" />
          </div>

          <div className="w-100 mt-4">
            <Form className="form-horizontal" onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <h5
                  style={{
                    fontSize: "17px",
                    fontWeight: "600",
                    borderLeft: "3px solid",
                    paddingLeft: "10px",
                    marginBottom: "16px",
                  }}
                >
                  Forgot Password
                </h5>

                <FormGroup className="mt-4">
                  <Label>Email Address</Label>
                  <Input
                    name="email"
                    className="form-control"
                    type="text"
                    placeholder="Email Address"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email || ""}
                    invalid={
                      formik.touched.email && formik.errors.email ? true : false
                    }
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <FormFeedback type="invalid">
                      {formik.errors.email}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </div>

              <p style={{ fontWeight: "600" }} className="">
                Enter your email address. We will send a recovary code to your
                email.
              </p>

              <ResultHandler error={error} />

              <Button
                color="primary"
                type="submit"
                disabled={loading}
                className="w-100 fw-bold"
              >
                {loading ? "Loading..." : "Send code"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
